'use client'

// types
import { ProductTypeProps } from '.'
import type { Props as HeadingProps } from '@dustin-web/microsite-components/src/heading'

// hooks
import { DigitalDataOrigin } from '../utils/digital-data-types'

// components
import ProductCardGalleryWithSideButtons from './sideButtons'

import Card from './gallery'

export type Props = {
  product: ProductTypeProps
  ticket: string
  slim?: boolean
  withBorder?: boolean
  imagePriority?: boolean
  isExtraItem?: boolean
  inFilterList?: boolean
  sizeClasses?: string
  cardClasses?: string
  mainProductErpIdentifier?: string
  digitalDataOrigin: DigitalDataOrigin
  digitalIndex?: number
  isProductAccessories?: boolean
  showFavoritesButton?: boolean
  primary?: boolean
  showActionRow?: boolean
  showProductButton?: boolean | 0 | null | undefined
  showProductPrice?: boolean
  preventSetLastUpdatedProductErpIdentifier?: boolean
  showProductBadge?: boolean
  showSideButtons?: boolean
  toggles?: any
  hTag?: HeadingProps['hTag']
}

export const ProductCardGallerySwitch = (props: Props) => {
  if (props.showSideButtons) {
    return <ProductCardGalleryWithSideButtons {...props} />
  } else {
    return <Card {...props} />
  }
}

export const ProductCardGallery = (props: Props) => <Card {...props} />

export default ProductCardGallery
